var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"justify-content":"center","align-items":"center","width":"100%","height":"100%"}},[_c('IframeAux',{attrs:{"id":"iframe-player","source":_vm.source,"isMobile":_vm.isMobile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }